import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'ホーム', href: '/#home' },
  { label: '会社概要', href: '/#about' },
  { label: 'サービス', href: '/#services' },
  { label: '特徴', href: '/#features' },
  { label: 'お問い合わせ', href: '/#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    if (href.startsWith('/#')) {
      const id = href.replace('/#', '');
      if (location.pathname !== '/') {
        window.location.href = href;
        return;
      }
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-[#0f1115]/95 backdrop-blur-md border-b border-white/5'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/77dafed2-8a02-43c0-b018-8b570d66b00c.png"
            alt="K・S Capital Logo"
            className="h-9 w-auto object-contain"
          />
          <span className="text-white font-bold text-lg tracking-wide hidden sm:block" style={{ fontFamily: 'Inter, sans-serif' }}>
            K・S <span className="text-[#38bdf8]">Capital</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => handleNavClick(item.href)}
              className="text-gray-200 hover:text-[#38bdf8] text-[15px] font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap relative group"
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#38bdf8] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => handleNavClick('/#contact')}
            className="px-5 py-2 rounded-md bg-gradient-to-r from-[#0ea5e9] to-[#38bdf8] text-white text-[15px] font-semibold hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer"
          >
            お問い合わせ
          </button>
        </div>

        {/* Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0f1115]/98 backdrop-blur-md border-t border-white/5 px-6 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => handleNavClick(item.href)}
              className="text-gray-200 hover:text-[#38bdf8] text-[15px] font-medium text-left transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => handleNavClick('/#contact')}
            className="mt-2 px-5 py-2 rounded-md bg-gradient-to-r from-[#0ea5e9] to-[#38bdf8] text-white text-[15px] font-semibold whitespace-nowrap cursor-pointer"
          >
            お問い合わせ
          </button>
        </div>
      )}
    </header>
  );
}
